import { useInfiniteQuery } from "@tanstack/react-query";

import { useAuth } from "@/providers";
import { useDomainServices } from "@/providers/DomainServices";

import { CommentEntityType } from "..";

import * as Comments from "./getQueryKey";

interface UseCommentsForEntityParams {
  entityType: CommentEntityType;
  entityId: string;
}

export function getQueryKey(params: UseCommentsForEntityParams) {
  const { entityType, entityId } = params;
  return [...Comments.getQueryKey(), "entity", entityType, entityId];
}

export function useCommentsForEntity(params: UseCommentsForEntityParams) {
  const { commentService } = useDomainServices();
  const { currentOrganization } = useAuth();
  const { entityType, entityId } = params;

  return useInfiniteQuery({
    queryKey: getQueryKey(params),
    queryFn: async ({ pageParam, signal }) => {
      if (!currentOrganization) {
        throw new Error("No organization selected");
      }

      return commentService.getCommentsForEntity(entityType, entityId, {
        orgId: currentOrganization.org_id,
        pageToken: pageParam,
        abortSignal: signal,
      });
    },
    select: (data) => data.pages.flatMap((page) => page.items),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage) => lastPage.next_token,
    enabled: currentOrganization !== null,
    // 1 minute. Chosen because comments are expected to update
    // more frequently than the default 5 min.
    staleTime: 60000,
  });
}
